import { useMemo } from 'react';
import { initApolloClient } from './initApolloClient.js';
// import type { AuthProps } from '../auth/server/types';
import { setItem } from './utils/storage.js';
/**
 *  Apollo client hook that optional takes a factory and client options
 * @param pageProps - next.js page props, but with __APOLLO__ state initial state set
 * @param factory - apollo client factory
 * @param options - apollo client options
 */
export function useApollo(pageProps, factory, options) {
    const state = pageProps.__APOLLO_STATE__;
    const store = useMemo(() => initApolloClient(state, factory, options), [state, factory, options]);
    let name;
    let token = '';
    if ('auth' in pageProps) {
        name = pageProps.auth.name;
        token = pageProps.auth.token;
    }
    useMemo(() => {
        if (name) {
            setItem(name, token);
        }
    }, [name, token]);
    return store;
}
//# sourceMappingURL=useApollo.js.map